module.exports = __webpack_public_path__ + "static/media/deploy_elastic_stack_to_kubernetes.80080fe2.md";